const events = require('events')

const EventEmitter = new events()

export default EventEmitter
